<template>
    <div class="m-update">
        <h5 class="title"></h5>
        <div class="slogen">
            <p>为老兵们提供更完善、明确的成长渠道</p>
        </div>        

        <div class="page-view">
            <!-- <div class="tab-hd">
                <div class="u-btn tab-btn tab-1" :class="{'act' : active_index == 0}" @click="active_index = 0"></div>
                <div class="u-btn tab-btn tab-2" :class="{'act' : active_index == 1}" @click="active_index = 1"></div>
                <div class="u-btn tab-btn tab-3" :class="{'act' : active_index == 2}" @click="active_index = 2"></div>
            </div> -->

            <div class="tab-bd">
                <div class="tab-view">
                    <div class="tab-wrapper" v-if="active_index == 0">
                        <div class="img-view"><img :src="require('@/assets/images/1.jpg')" alt="" srcset=""></div>
                            <div class="content-view">
                                <div class="t-update u-1"></div>
                                <div class="text">朱雀降临，星宿守护！第十四届征战天下开启，梦庞统/关凤/文丑/梦孙策/文丑/司马懿全新征战换装上线！</div>
                                <div class="more"><a href="https://www.m3guo.com/activity/202312/version-dhle/" target="_blank" rel="noopener noreferrer"></a></div>
                            </div>
                        </div>
                   

                   
                        <div class="tab-wrapper" v-if="active_index == 1">
                            <div class="img-view"><img :src="require('@/assets/images/3.png')" alt="" srcset=""></div>
                            <div class="content-view">
                                <div class="t-update u-3"></div>
                                <div class="text">仙术师，欢迎重回梦三大陆，我们将为您准备一份回归大礼包，并为了让您能更快融入游戏，准备了丰富的回归福利，快前往登录游戏领取吧！</div>
                            </div>                            
                        </div>
                    

                                                      

                </div>

                <div class="u-btn prev" @click="prev()"></div>
                <div class="u-btn next" @click="next()"></div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.title{
    width: 808px;
    height: 175px;
    margin: 0 auto 20px;
    background-image: url(~@/assets/images/pc/title-5.png);
}

.tab-hd{
    display: flex;
    justify-content: space-between;
    width: 1200px;
    margin: 44px auto 55px;
}

.tab-hd .u-btn{
    width: 395px;
    height: 91px;
}

.tab-hd .u-btn.tab-1{
    background-image: url(~@/assets/images/pc/tab-2.png);
}

.tab-hd .u-btn.tab-1.act{
    background-image: url(~@/assets/images/pc/tab-2_act.png);
}

.tab-hd .u-btn.tab-2{
    background-image: url(~@/assets/images/pc/tab-1.png);
}

.tab-hd .u-btn.tab-2.act{
    background-image: url(~@/assets/images/pc/tab-1_act.png);
}

.tab-hd .u-btn.tab-3{
    background-image: url(~@/assets/images/pc/tab-3.png);
}

.tab-hd .u-btn.tab-3.act{
    background-image: url(~@/assets/images/pc/tab-3_act.png);
}

.tab-bd{
    position: relative;
    width: 1200px;
    height: 485px;
    margin: 60px auto 0;
    background-image: url(~@/assets/images/pc/bg-tab.png);
}

.tab-wrapper{
    display: flex;
    justify-content: space-between;
    padding: 40px 65px 0;
}

.img-view{
    position: relative;
    width: 657px;
    height: 388px;
    background-image: url(~@/assets/images/pc/img-view.png);
}

.img-view img{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
}

.more{
    position: absolute;
    left: 20px;
    bottom: 30px;
    width: 239px;
    height: 84px;
    background-image: url(~@/assets/images/pc/more.png);
}

.more a{
    display: block;
    width: 100%;
    height: 100%;
}


.content-view{
    position: relative;
    width: 345px;
    min-height: 340px;
    margin-top: 20px;
    padding-left: 16px;
    box-sizing: border-box;
    /* background-image: url(~@/assets/images/pc/bg-line.png); */
    background-position: left center;
    background-repeat: no-repeat;
}

.t-update{
    width: 339px;
    height: 37px;
    margin: 0 auto 30px;
}

.t-update.u-1{
    background-image: url(~@/assets/images/pc/update-1.png);
}

.t-update.u-2{
    background-image: url(~@/assets/images/pc/update-1.png);
}

.t-update.u-3{
    background-image: url(~@/assets/images/pc/update-2.png);
}

.content-view .text{
    font-size: 16px;
    color: #49392e;
    line-height: 1.6;
}

.u-btn.prev{
    position: absolute;
    left: -100px;
    top: 50%;
    margin-top: -25px;
    width: 50px;
    height: 50px;
    background-image: url(~@/assets/images/pc/btn-prev.png);
}

.u-btn.next{
    position: absolute;
    right: -100px;
    top: 50%;
    margin-top: -25px;
    width: 50px;
    height: 50px;
    background-image: url(~@/assets/images/pc/btn-next.png);
}
</style>

<script>
export default {
    data(){
        return {
            active_index : 0,
        }
    },
    methods : {
        next (){
            if(this.active_index == 1)return this.active_index = 0;
            this.active_index = Math.min(++this.active_index , 1);
        },
        prev (){
            if(this.active_index == 0)return this.active_index = 1;
            this.active_index = Math.max(--this.active_index , 0);
        },        
    },
}
</script>


// WEBPACK FOOTER //
// src/view/update.vue